export class Request {
  workRequestId: number;
  offerId: number;
  upisId: string;
  name: string;
  quantity: number;
  unit: string;
  client: string;
  assignees: any;
  assigneeId: string;
  assigneeName: string;
  assigneePhoto: string;
  deliveryDeadline: Date;
  offerDeadline: Date;
  receiptOfRequestDate: Date;
  status: string;
  documentationListStatus: string;
  materialsListStatus: string;
  operationsListStatus: string;
  calculatorStatus: string;
  contactName: string;
  contactNameUpis: string;
  requestType: string;
  clientId: number;
  clientName: string;
  clientNameUpis: string;
  clientPib: string;
  clientPibUpis: string;
  contactPhone: string;
  contactPhoneUpis: string;
  description: string;
  clientDocumentation: Array<string>;
  requestServices: Array<string>;
  requestJobType: Array<string>;
  requestDeliveryType: string;
  exportation: boolean;
  exportationDocumentation: Array<string>;
  existingContract: boolean;
  existingContractDocumentation: Array<string>;
  documentationLink: Array<string>;
  initiallyDeclined: boolean;
  initiallyRejectedRequest: boolean;
  expectedIncome: number;
  expectedRevenue: string;
  productCategories: Array<{ name: string }>;
  materialType: string;
  rejectionReasons: Array<string>;
  rejectionComment: string;
  sectors: any;
  isActive: boolean;
  specification: string;
  specificationPhotos: Array<string>;
  numberOfRequests: number;
  createdAt: Date;
  externalServices: Array<string>;
  originalPrice: number;
  specificationDeadline: Date;
  calculatorDeadline: Date;
  agencyCommissionPercentage: number;
  finalSellingPrice: number;
  optimalSellingPrice: number;
  deliveryAddress: string;
  designDeadline: Date;
  startDevelopmentDate: Date;
  developmentDeadline: Date;
  graphicDocumentationCompletionDate: Date;
  engineerDocumentationCompletionDate: Date;
  graphicMaterialsCompletionDate: Date;
  engineerMaterialsCompletionDate: Date;
  productionEstimatedTime: string;
  linkTo: Array<LinkedWorkOrder>;
  isLinked: boolean;
  calculatorTemp: CalculatorTemp;
  clonedFromWorkRequestId: string;
  complexity: number;

  constructor(request) {
    this.workRequestId = request.workRequestId || undefined;
    this.offerId = request.offerId || undefined;
    this.upisId = request.upisId || undefined;
    this.name = request.name || undefined;
    this.quantity = request.quantity || undefined;
    this.unit = request.unit || undefined;
    this.client = request.client || undefined;
    this.deliveryDeadline = request.deliveryDeadline || undefined;
    this.offerDeadline = request.offerDeadline || undefined;
    this.status = request.status || undefined;
    this.documentationListStatus = request.documentationListStatus || undefined;
    this.materialsListStatus = request.materialsListStatus || undefined;
    this.operationsListStatus = request.operationsListStatus || undefined;
    this.calculatorStatus = request.calculatorStatus || undefined;
    this.sectors = request.sectors || undefined;
    this.receiptOfRequestDate = request.receiptOfRequestDate || undefined;
    this.contactName = request.contactName || undefined;
    this.contactNameUpis = request.contactNameUpis || undefined;
    this.requestType = request.requestType || undefined;
    this.clientId = request.clientId || undefined;
    this.clientName = request.clientName || undefined;
    this.clientNameUpis = request.clientNameUpis || undefined;
    this.clientPib = request.clientPib || undefined;
    this.clientPibUpis = request.clientPibUpis || undefined;
    this.contactPhone = request.contactPhone || undefined;
    this.contactPhoneUpis = request.contactPhoneUpis || undefined;
    this.description = request.description || undefined;
    this.clientDocumentation = request.clientDocumentation || undefined;
    this.requestServices = request.requestServices || undefined;
    this.requestDeliveryType = request.requestDeliveryType || undefined;
    this.requestJobType = request.requestJobType || undefined;
    this.exportation = request.exportation || false;
    this.exportationDocumentation = request.exportationDocumentation || undefined;
    this.existingContract = request.existingContract || false;
    this.existingContractDocumentation = request.existingContractDocumentation || undefined;
    this.documentationLink = request.documentationLink || undefined;
    this.initiallyDeclined = request.initiallyDeclined ?? request.initiallyRejectedRequest ?? false;
    this.initiallyRejectedRequest = request.initiallyRejectedRequest ?? request.initiallyDeclined ?? false;
    this.expectedIncome = request.expectedIncome ?? request.expectedRevenue ?? undefined;
    this.expectedRevenue = request.expectedRevenue ?? request.expectedIncome ?? undefined;
    this.productCategories = request.productCategories || [];
    this.materialType = request.materialType || undefined;
    this.rejectionReasons = request.rejectionReasons || [];
    this.rejectionComment = request.rejectionComment || undefined;
    this.isActive = request.isActive;
    this.assignees = request.assignees || undefined;
    this.assigneeId = request.assigneeId || undefined;
    this.assigneeName = request.assigneeName || undefined;
    this.assigneePhoto = request.assigneePhoto || undefined;
    this.specification = request.specification || undefined;
    this.specificationPhotos = request.specificationPhotos || undefined;
    this.numberOfRequests = request.numberOfRequests || undefined;
    this.createdAt = request.createdAt || undefined;
    this.externalServices = request.externalServices || undefined;
    this.originalPrice = request.originalPrice || undefined;
    this.specificationDeadline = request.specificationDeadline || undefined;
    this.calculatorDeadline = request.calculatorDeadline || undefined;
    this.agencyCommissionPercentage = request.agencyCommissionPercentage || undefined;
    this.finalSellingPrice = request.finalSellingPrice || undefined;
    this.optimalSellingPrice = request.optimalSellingPrice || undefined;
    this.deliveryAddress = request.deliveryAddress || undefined;
    this.designDeadline = request.designDeadline || undefined;
    this.startDevelopmentDate = request.startDevelopmentDate || undefined;
    this.developmentDeadline = request.developmentDeadline || undefined;
    this.engineerDocumentationCompletionDate = request.engineerDocumentationCompletionDate || undefined;
    this.graphicDocumentationCompletionDate = request.graphicDocumentationCompletionDate || undefined;
    this.engineerMaterialsCompletionDate = request.engineerMaterialsCompletionDate || undefined;
    this.graphicMaterialsCompletionDate = request.graphicMaterialsCompletionDate || undefined;
    this.productionEstimatedTime = request.productionEstimatedTime || undefined;
    this.linkTo = request.linkTo || undefined;
    this.isLinked = request.isLinked || false;
    this.calculatorTemp = request.calculatorTemp || undefined;
    this.clonedFromWorkRequestId = request.clonedFromWorkRequestId || undefined;
    this.complexity = request.complexity || undefined;
  }
}

class LinkedWorkOrder {
  workOrderId: string;
  workOrderName: string;
  workOrderUpisId: boolean;
}

class CalculatorTemp {
  count: number;
  transportationCost: number;
  additionalWork: number;
}
